import { InjectionToken } from '@angular/core'
import { ListenerDictionary } from './video-player.events'
import { HlsLoader, uuidPerTabGenFn } from './video-player.interfaces'

export const VIDEO_PLAYER_HLS_URL_LOADER = new InjectionToken<HlsLoader>('app.vid.hls-loader')
export const VIDEO_PLAYER_EVENT_BINDINGS = new InjectionToken<ListenerDictionary>('app.vid.evt.binders')
export const VIDEO_PLAYER_EVENT_UUID_TAB_GENERATOR = new InjectionToken<uuidPerTabGenFn>('app.vid.window.hash')
